import { s } from './safe';

export const stripePk = s(s(window).env).REACT_APP_STRIPE_PK;
